'use strict';
// TODO: Remove from `core-js@4`
var $ = require('../internals/export');
var indexed = require('../internals/iterator-indexed');

// `Iterator.prototype.indexed` method
// https://github.com/tc39/proposal-iterator-helpers
$({ target: 'Iterator', proto: true, real: true, forced: true }, {
  indexed: indexed
});
